import { Fragment, useState } from 'react';
import { generalStyle } from 'helper/Style';
import { ObjectType, OperationType, ModalTextSet, getModalText } from 'helper/ModalText';
import Modal, { modalStyle } from 'component/part/Modal';

export type OperationTriggerProps = {
  onSubmit: () => Promise<boolean>;
  onConfirm?: () => boolean | Promise<boolean>;
  onOk?: () => void | Promise<void>;
  onCancel?: () => void;
  buttonText: string;
  okText?: string;
  className?: string;
  /** objectType + operationType を指定すると ModalText から文言を自動解決する */
  objectType?: ObjectType;
  operationType?: OperationType;
  /** objectType/operationType の文言を部分的に上書きしたい場合に使用 */
  textOverride?: Partial<ModalTextSet>;
  /** @deprecated objectType/operationType を使用してください */
  confirmText?: string;
  /** @deprecated objectType/operationType を使用してください */
  doneText?: string;
  /** @deprecated objectType/operationType を使用してください */
  errorText?: string;
  /** @deprecated objectType/operationType を使用してください */
  submitText?: string;
};

const OperationTrigger = (props: OperationTriggerProps) => {
  const [status, setStatus] = useState<'confirm' | 'done' | 'error' | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const baseTexts = (props.objectType && props.operationType)
    ? getModalText(props.objectType, props.operationType)
    : {
      confirm: props.confirmText ?? '',
      submit: props.submitText ?? '',
      done: props.doneText ?? '',
      error: props.errorText ?? '',
    };
  const texts = { ...baseTexts, ...props.textOverride };
  const modalText = status
    ? { confirm: texts.confirm, done: texts.done, error: texts.error }[status]
    : '';

  const onConfirm = async () => {
    const confirmed = props?.onConfirm ? await props.onConfirm() : true;
    if (confirmed) {
      setStatus('confirm');
    }
  };

  const onSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    setStatus(null);
    try {
      const result = await props.onSubmit();
      setStatus(result ? 'done' : 'error');
    } catch {
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const onOk = () => {
    setStatus(null);
    props.onOk
      ? props.onOk()
      : props.onCancel?.();
  };

  const onCancel = () => {
    setStatus(null);
    props.onCancel?.();
  };

  return <Fragment>
    <div css={generalStyle.formRow} className={props.className}>
      <button type='button' onClick={onConfirm} disabled={submitting} css={generalStyle.button('normal', submitting)}>{props.buttonText}</button>
    </div>
    <Modal display={!!status} onHide={status === 'done' ? onOk : onCancel}>
      <div>{modalText}</div>
      <div css={modalStyle.buttonArea}>
        {status === 'confirm' ? (
          <Fragment>
            <button onClick={onSubmit} disabled={submitting} css={generalStyle.button('normal', submitting)}>{texts.submit}</button>
            <button onClick={onCancel} css={generalStyle.button('warning')}>キャンセル</button>
          </Fragment>
        ) : (
          <button onClick={status === 'done' ? onOk : onCancel} css={generalStyle.button()}>
            {props.okText || 'OK'}
          </button>
        )}
      </div>
    </Modal>
  </Fragment>;
};

export default OperationTrigger;
